// extracted by mini-css-extract-plugin
module.exports =  {"container":"_JkLAl38TRp2UdI6nd1J"};